// ** React Imports
import { useState, useEffect, useContext, useMemo } from "react";

// ** Redux
import { useSelector } from "react-redux";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// ** Custom Hooks
import usePWAInstalable from "hooks/usePWAInstalable";
import useScrollAnimation from "hooks/useScrollAnimation";
import { ScrollToTopButton } from "./components/ScrollToTopButton";

// #####################################################

const ScrollToTop = ({ isLanding = false }) => {
	const [showTopBtn, setShowTopBtn] = useState(false);
	const isAuth = useSelector((state) => state.globalCommon.isAuth);
	const { isPhone, isTablet, isDesktop } = useContext(deviceTypeContext);

	const isSSR = typeof window === "undefined";

	// ** Odczytanie z localStorage czasu kiedy kliknięto przycisk zaknięcia
	const bottomFloatingBarClosedTimestamp = isSSR
		? 0
		: localStorage
		? localStorage.getItem("bottomFloatingBarClosedTimestamp") || 0
		: 0;

	// ** Obliczanie różnicy - ile dni minęło od kliknięcia w przycisk
	// ** zamykający pasek informujący o możliwości instalacji aplikacji
	const bottomFloatingBarCloseTime = parseInt(
		bottomFloatingBarClosedTimestamp,
		10
	);

	const currentTime = Date.now();
	const timeDiff = currentTime - bottomFloatingBarCloseTime;
	const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000;

	// ** Czy pokazać pasek - warunek liczby dni od zamknięcia
	const shouldShowFloatingBar = timeDiff >= thirtyDaysInMilliseconds;

	// ** Sprawdzenie czy można zainstalować aplikację PWA w danej przeglądarce
	const { installStatus } = usePWAInstalable();

	const goToTop = useScrollAnimation(200, 0);

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 600) {
				setShowTopBtn(true);
			} else {
				setShowTopBtn(false);
			}
		};

		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	const buttonPosition = useMemo(() => {
		if (isAuth && (isPhone || isTablet)) {
			if (shouldShowFloatingBar && installStatus?.isInstallAllowed) {
				return 6;
			}
			return 1;
		} else if (isAuth && isDesktop) {
			return 1;
		} else {
			if (isLanding && (isPhone || isTablet)) {
				return 5.5;
			} else if (isPhone || isTablet) {
				return 5.5;
			} else {
				return 1;
			}
		}
	}, [
		shouldShowFloatingBar,
		installStatus?.isInstallAllowed,
		isPhone,
		isTablet,
		isAuth,
		isDesktop,
		isLanding,
	]);

	// #####################################################

	return (
		<>
			{showTopBtn && (
				<ScrollToTopButton
					onClick={goToTop}
					style={{
						bottom: `${buttonPosition}rem`,
					}}
				/>
			)}
		</>
	);
};

// #####################################################

export default ScrollToTop;

// #####################################################
